module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_M4-31b423c2908c47f39e1eb2a4587f48e4.png";